import Select from 'react-select';

function TableRowsConsumption({ rowsData, products, onChange, onRemove, readOnly = false }) {
    const productOptions = (products || []).map((p) => ({
        value: p.id,
        label: p.name,
        unit: p.unit?.name || p.unit_name || 'Kg',
    }));

    const handleProductSelect = (index, option) => {
        const updated = [...rowsData];
        updated[index] = {
            ...updated[index],
            product_id: option?.value || '',
            product_name: option?.label || '',
            unit: option?.unit || updated[index].unit || 'Kg',
        };
        onChange(updated);
    };

    const handleFieldChange = (index, name, value) => {
        const updated = [...rowsData];
        updated[index] = { ...updated[index], [name]: value };
        onChange(updated);
    };

    return (
        <>
            {rowsData.map((row, index) => (
                <tr key={row.line_no || index} className="text-center detailclass">
                    {!readOnly && (
                        <td>
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => onRemove(index)}
                            >
                                Remove
                            </button>
                        </td>
                    )}
                    <td>{index + 1}</td>
                    <td style={{ minWidth: '200px' }}>
                        {readOnly ? (
                            row.product_name
                        ) : (
                            <Select
                                options={productOptions}
                                value={productOptions.find((o) => o.value === row.product_id) || null}
                                onChange={(opt) => handleProductSelect(index, opt)}
                                placeholder="Select material"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    control: (base) => ({ ...base, minHeight: '32px' }),
                                }}
                            />
                        )}
                    </td>
                    <td>
                        {readOnly ? row.material_label : (
                            <input
                                className="form-control form-control-sm"
                                value={row.material_label || ''}
                                onChange={(e) => handleFieldChange(index, 'material_label', e.target.value)}
                            />
                        )}
                    </td>
                    <td>
                        {readOnly ? row.design_mix_qty : (
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                style={{ textAlign: 'right' }}
                                value={row.design_mix_qty || 0}
                                onChange={(e) => handleFieldChange(index, 'design_mix_qty', e.target.value)}
                            />
                        )}
                    </td>
                    <td>
                        {readOnly ? row.consumed_qty : (
                            <input
                                type="number"
                                className="form-control form-control-sm mandatory-form-control"
                                style={{ textAlign: 'right' }}
                                value={row.consumed_qty || 0}
                                onChange={(e) => handleFieldChange(index, 'consumed_qty', e.target.value)}
                                required
                            />
                        )}
                    </td>
                    <td>{row.unit || 'Kg'}</td>
                </tr>
            ))}
        </>
    );
}

export default TableRowsConsumption;
